export default "<div>\r\n    <lean-menu [menu]=\"packingMenu\"      [shrinkMode] = 'shrinkMode' (onSelect)=\"select($event)\"></lean-menu>\r\n</div>\r\n"